import { PermissionScope } from "@/modules/auth";
import type {
  Operator as AccountsOperator,
  OperatorCreate,
  OperatorUpdate,
} from "@/providers/smarta-accounts/accounts-api-client";

/**
 * Operator record from smarta-accounts. Re-exported from the generated accounts
 * client (the source of truth) so call sites talk to the same shape the API
 * returns — the operator surface is consumed through `modules/integrations/accounts`,
 * the same way banking consumes its generated client.
 */
export type Operator = AccountsOperator;

export type OperatorCreatePayload = OperatorCreate;

export type OperatorUpdatePayload = OperatorUpdate;

/**
 * Backend operators only ever return one of these 5 scopes. The wider
 * `PERMISSION_SCOPES` enum (which also includes legacy DIY / INVALID) is
 * kept on the client for runtime guards, but the operator-management
 * dropdown must only show the 5 backend values.
 */
export const OPERATOR_PERMISSION_SCOPES = [
  "TAX_SUPERVISOR",
  "ADMIN",
  "CLERK",
  "ACCOUNTING",
  "READONLY",
] as const satisfies PermissionScope[];

/**
 * Local-only sentinel used as the row id while an "Add new" form is
 * staged but not yet persisted. Real operator ids from smarta-accounts
 * never start with two underscores.
 */
export const NEW_OPERATOR_SENTINEL = "__new__";
